module.exports = __webpack_public_path__ + "img/icon180.b01b2149.png";